import { EditorSettings } from '$src/domain/designs/settings/EditorSettings';
import type { IEditorSettingsRepository } from '$src/domain/designs/settings/IEditorSettingsRepository';
import axios from 'axios';
import { injectable } from 'tsyringe';

@injectable()
export class EditorSettingsRepository implements IEditorSettingsRepository {
  
    private apiClient = axios.create({ baseURL: 'https://api.example.com' });

    constructor() {
        
    }

    getByUsernameAsync(username: string): Promise<EditorSettings> {
        return Promise.resolve(new EditorSettings());
    }
    createOrUpdateAsync(editorSetting: EditorSettings): Promise<void> {
        throw new Error('Method not implemented.');
    }
}
